import Icon from 'veui/components/Icon'
import { IconClockSolid } from 'dls-icons-vue'

Icon.register('clock-solid', IconClockSolid)
